import { IStopAddress } from '../stop';

/** The domestic country of the platform freights. */
const DOMESTIC_COUNTRY_CODE = 'ES';

/**
 * A freight is international when any of its stops is outside the domestic country. The rule is
 * the same for the freights of carriers, shippers and the available market (freight-common).
 * A stop without country code does not make the freight international (missing data).
 */
export function isFreightInternational(stops: ReadonlyArray<{ address?: IStopAddress | null }>): boolean {
  return stops.some((stop) => {
    const countryCode = stop?.address?.countryCode;
    return !!countryCode && countryCode !== DOMESTIC_COUNTRY_CODE;
  });
}
